import {
    STORE_FULL_TRUCKLOAD,
    STORE_FULL_TRUCKLOAD_BROKERS,
    STORE_FULL_TRUCKLOAD_CARRIERS,
    STORE_FULL_TRUCKLOAD_FILE,
    STORE_FULL_TRUCKLOAD_DOCUMENT,
    STORE_FULL_TRUCKLOAD_SETTINGS,
    STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE,
    STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS,
    STORE_FULL_TRUCKLOAD_SIGNATURES,
    STORE_FULL_TRUCKLOAD_SIGNATURE,
    STORE_SAVE_SIGNATURE_RESPONSE,
    CLEAR_RESPONSE_MESSAGE, CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE, STORE_FULL_TRUCKLOAD_PORTS, STORE_PRODUCTS_SUPPLIERS, STORE_SAVE_POE_RESPONSE, STORE_SAVE_FTL_SETTING_RESPONSE
} from "../../constants/fullTruckload";
import {previewingFullTruckloadDataSelector} from "../../selectors/fullTruckload";

const initialState = {
    fullTruckloads: [],
    fullTruckloadSettings: {},
    fullTruckloadSignatures: {},
    fullTruckloadPorts: {},
    savePoeResponseMessage: "",
    saveFtlSettingResponseMessage: "",
    productsSupplier: [],
    fullTruckloadCarriers: [],
    fullTruckloadBrokers: [],
    previewingFullTruckloadData: [],
    operationResponse:"",
    unavailableItems:[],
    signatureResponseMessage: "",
}

const addPreviewToFullTruckloadSettings = (updatedSettings, index, oldSettings) => {
    let filePreviewInfo = updatedSettings.attachments.pop()
    let previewedFileIndex = index
    let previewData = new Uint8Array(filePreviewInfo.previewFile)
    let blobData = new Blob([previewData])
    if (index === -1) {
        updatedSettings.billOfLading["localURL"] = URL.createObjectURL(blobData)
        updatedSettings.billOfLading['byteArray'] = previewData

        oldSettings.billOfLading = updatedSettings.billOfLading
    }
    else {
        updatedSettings.attachments[previewedFileIndex]['file']["localURL"] = URL.createObjectURL(blobData)
        updatedSettings.attachments[previewedFileIndex]['file']['byteArray'] = previewData
        updatedSettings.attachments[previewedFileIndex]['file']['displayName'] = filePreviewInfo.displayName

        oldSettings.attachments[previewedFileIndex] = updatedSettings.attachments[previewedFileIndex]
    }

    return {...oldSettings}
}

const addPreviewToFullTruckloadSignatures = (updatedSignatures, previewedFileIndex, oldSettings) => {
    // Get the last signature info from updatedSignatures
    let filePreviewInfo = updatedSignatures.pop();
    // Convert the preview data to a Blob and create a local URL
    let previewData = new Uint8Array(filePreviewInfo.previewFile);
    let blobData = new Blob([previewData]);
    // Create a new object to avoid mutating the original updatedSignatures
    let updatedSignature = {
        ...updatedSignatures[previewedFileIndex],
        file: {
            ...updatedSignatures[previewedFileIndex].file,
            localURL: URL.createObjectURL(blobData),
            byteArray: previewData,
            displayName: filePreviewInfo.displayName
        }
    };
    // Create a new oldSettings array to avoid mutating the original oldSettings
    let newSettings = [...oldSettings];
    newSettings[previewedFileIndex] = updatedSignature;
    return newSettings;
}

const addPreviewToFullTruckload = (updatedFullTruckload, fullTruckloads) => {
    let filePreviewInfo = updatedFullTruckload.finalDocument
    let previewData = new Uint8Array(filePreviewInfo.previewFile)
    let blobData = new Blob([previewData])

    updatedFullTruckload.finalDocument["localURL"] = URL.createObjectURL(blobData)
    updatedFullTruckload.finalDocument['byteArray'] = previewData

    for (let i = 0; i < fullTruckloads.length; i++) {
        if (fullTruckloads[i].fullTruckloadId === updatedFullTruckload.fullTruckloadId) {
            fullTruckloads[i].finalDocument = updatedFullTruckload.finalDocument
            break
        }
    }

    return [...fullTruckloads]
}

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_FULL_TRUCKLOAD:
            return {
                ...state,
                fullTruckloads: action.data
            }
        case STORE_PRODUCTS_SUPPLIERS:
            return {
                ...state,
                productsSupplier: action.suppliers
            }
        case STORE_FULL_TRUCKLOAD_SETTINGS:
            return {
                ...state,
                fullTruckloadSettings: action.data
            }
        case CLEAR_RESPONSE_MESSAGE:
            return {
                ...state,
                signatureResponseMessage: ""
            }
        case CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE:
            return {
                ...state,
                saveFtlSettingResponseMessage: ""
            }
        case STORE_SAVE_SIGNATURE_RESPONSE:
            return {
                ...state,
                signatureResponseMessage: action.data
            }
        case STORE_FULL_TRUCKLOAD_SIGNATURES:
            return {
                ...state,
                fullTruckloadSignatures: action.data?.signatures
            }
        case STORE_FULL_TRUCKLOAD_PORTS:
            return {
                ...state,
                fullTruckloadPorts: action.data
            }
        case STORE_SAVE_POE_RESPONSE:
            return {
                ...state,
                savePoeResponseMessage: action.data
            }
        case STORE_SAVE_FTL_SETTING_RESPONSE:
            return {
                ...state,
                saveFtlSettingResponseMessage: action.data
            }
        case STORE_FULL_TRUCKLOAD_FILE:
            return {
                ...state,
                fullTruckloadSettings: addPreviewToFullTruckloadSettings(action.fullTruckloadSettings, action.index, state.fullTruckloadSettings)
            }
        case STORE_FULL_TRUCKLOAD_SIGNATURE:
            return {
                ...state,
                fullTruckloadSignatures: addPreviewToFullTruckloadSignatures(action.fullTruckloadSignatures, action.index, state.fullTruckloadSignatures)
            }
        case STORE_FULL_TRUCKLOAD_DOCUMENT:
            return {
                ...state,
                previewingFullTruckloadData: action.data
            }
        case STORE_FULL_TRUCKLOAD_CARRIERS:
            return {
                ...state,
                fullTruckloadCarriers: action.data
            }
        case STORE_FULL_TRUCKLOAD_BROKERS:
            return {
                ...state,
                fullTruckloadBrokers: action.data
            }
        case STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE:
            return {
                ...state,
                operationResponse: action.message
            }
        case STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS:
            return {
                ...state,
                unavailableItems: action.items ?? []
            }
        default:
            return state;
    }
}